import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {navigate} from "gatsby";
import userService from "../services/user";
const ConfirmDialog = (props) => {
    const { title, children, open, setOpen, onConfirm, onDeny, onReturn } = props;
    let returnButton;
    if(userService.currentUser?.jessicas_room && userService.currentUser?.app_type == "seventeen_days") {
        returnButton = <Button
            variant="contained"
            onClick={() => {
                setOpen(false);
                onReturn();
            }}
            color="default"
        >
            Jessica's Room
        </Button>
    } else if (userService.currentUser?.app_type == "your_move")  {
        returnButton = <Button
            variant="contained"
            onClick={() => {
                setOpen(false);
                onReturn();
            }}
            color="default"
        >
            Back to Lessons
        </Button>
    } else {
        returnButton = null;
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="confirm-dialog"
        >
            <DialogTitle id="confirm-dialog">{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        onDeny();

                    }}
                    color="secondary"
                >
                    Play from the beginning
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                    color="default"
                >
                    Resume Video
                </Button>
                {returnButton}

            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;